<template>
    <div class="container-fluid p-users">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">{{ $locale.patient }}一覧</div>

                    <div class="card-body p-users__content pt-2">
                        <div class="d-block d-md-flex justify-content-between mb-3">
                            <div class="d-block d-md-flex flex-wrap align-items-center">
                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="search.prefecture"
                                            @change="onChangeSearchPrefecture"
                                            id="prefmap"
                                            style="min-width: 100px;"
                                            class="form-control">
                                            <option :value="null">都道府県で検索</option>
                                            <option v-for="pref in prefmap" :value="pref">
                                                {{ pref }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select v-model="search.user_category_id"
                                                @change="onChangeSearchUserCategoryId"
                                                id="user_category_id"
                                                style="min-width: 100px;"
                                                class="form-control">
                                            <option :value="null">{{ $locale.patient }}区分で検索</option>
                                            <option v-for="userCategory in userCategories" :value="userCategory.id">
                                                {{ userCategory.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="search.plan_id"
                                            @change="onChangeSearchPlanId"
                                            id="user_category_id"
                                            style="min-width: 100px;"
                                            class="form-control">
                                            <option :value="null">サービスモデルで検索</option>
                                            <option v-for="plan in plans" :value="plan.id">
                                                {{ plan.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="search.user_management_tag_id"
                                            @change="onChangeSearchUserManagementTagId"
                                            id="doctor_management_tag_id"
                                            style="min-width: 100px;"
                                            class="form-control">
                                            <option :value="null">管理用タグで検索</option>
                                            <option
                                                v-for="userManagementTag in userManagementTags"
                                                :key="`doctor_management_tag_id_${userManagementTag.id}`"
                                                :value="userManagementTag.id">
                                                {{ userManagementTag.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mb-2 mb-md-0">
                                    <div class="c-freeword input-group input-group-sm">
                                        <input
                                            v-model="search.freeword"
                                            @blur="onChangeSearchFreeword"
                                            type="text"
                                            class="form-control"
                                            placeholder="フリーワード">
                                        <div class="input-group-append">
                                            <div
                                                class="c-freeword__btn input-group-text"
                                                @click="onChangeSearchFreeword">
                                                検索
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <span class="small">登録日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.registered_at_gte"
                                                @change="onChangeSearchRegisteredAtGte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.registered_at_lte"
                                                @change="onChangeSearchRegisteredAtLte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 mt-md-2 mb-2 mb-md-0 ml-0 ml-md-2 text-right">
                                <button
                                    type="button"
                                    class="btn btn-yokumiru-orange"
                                    style="min-width: 100px;"
                                    @click="showModalAddUser()">{{ $locale.patient }}追加
                                </button>
                            </div>
                        </div>

                        <div :class="{ 'u-loader u-loader--p5' : ! users }">
                            <div v-if="users">
                                <b-table
                                    hover
                                    striped
                                    responsive
                                    :items="users"
                                    :fields="fields"
                                    :sort-by.sync="$store.state.adminUsers.sortBy"
                                    :sort-desc.sync="$store.state.adminUsers.sortDesc"
                                    @sort-changed="fetchUsers"
                                    class="table-bordered m-table"
                                    :class="{ 'b-table--has-plan' : $store.state.configs.subscription == 1 }">
                                    <template v-slot:cell(full_name_kana)="data">
                                        <a href="#" @click="showModalUserProfile(data.item, $event)">
                                            {{ data.item.full_name }}
                                        </a>
                                        <div class="small">{{ data.item.full_name_kana }}</div>
                                        <div
                                            v-if="data.item.is_organization"
                                            class="small mt-1">
                                            <a :href="`/admin/organizations/${userOrganization(data.item).id}`">
                                                <b-icon-people-fill/>
                                                <span>{{ userOrganization(data.item).name }}</span>
                                            </a>
                                        </div>
                                        <div
                                            v-if="data.item.is_company"
                                            class="small mt-1">
                                            <a :href="`/admin/companies/${userCompany(data.item).id}`">
                                                <b-icon-building/>
                                                <span>{{ userCompany(data.item).name }}</span>
                                            </a>
                                        </div>
                                        <div class="d-flex align-items-center small">
                                            <a
                                                href="#"
                                                @click="showModalUserGroupHistories(data.item, $event)">
                                                グループ所属履歴を表示
                                            </a>
                                        </div>
                                    </template>

                                    <template v-slot:cell(user_category_id)="data">
                                        <div v-for="userCategory in userCategories">
                                            <div v-if="userCategory.id === data.item.user_category_id">
                                                {{ userCategory.name }}
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:cell(plan_id)="data">
                                        <div v-if="data.item.plan">{{ data.item.plan.name.replace('サービスモデル', '') }}</div>
                                        <div class="d-flex align-items-center small">
                                            <a
                                                href="#"
                                                @click="showModalSubscriptionHistories(data.item, $event)">
                                                サービスモデル履歴を表示
                                            </a>
                                        </div>
                                    </template>

                                    <template v-slot:cell(user_management_tags.name)="data">
                                        <div class="userManagementTagsWrapper d-flex align-items-center">
                                            <div
                                                v-for="tag in data.item.user_management_tags"
                                                class="d-flex align-baseline">
                                                <div class="userManagementTag d-flex justify-content-center align-items-center">{{ tag.name }}</div>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:cell(user_coupons_available_all)="data">
                                        <div
                                            v-if="data.item.user_coupons_available_all.length > 0"
                                            class="td-user-coupons d-flex">
                                            <span v-for="user_coupon in data.item.user_coupons_available_all">{{ user_coupon.coupon.name }}</span>
                                        </div>
                                    </template>

                                    <template v-slot:cell(latest_consultation_start_time)="data">
                                        <div v-if="data.item.latest_consultation">
                                            <div class="u-palt">
                                                <span class="small">
                                                    {{ helper.dateForHuman(data.item.latest_consultation.start_time, timezone, { simpleYear: true }) }}
                                                </span>
                                                <span
                                                    class="small font-weight-bold"
                                                    :class="helper.dayForHumanCSS(data.item.latest_consultation.start_time , timezone)">
                                                    {{ helper.dayForHuman(data.item.latest_consultation.start_time, timezone, { bracket: true }) }}
                                                </span>
                                            </div>
                                            <div class="small">
                                                {{ helper.timeForHuman(data.item.latest_consultation , timezone) }}
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:cell(birthday)="data">
                                        <!-- ageは仮装フィールドなのでbirthdayでソートする（実質同じ結果になる） -->
                                        <span>{{ data.item.age }}</span>
                                    </template>

                                    <template v-slot:cell(prefecture)="data">
                                        <div class="td-prefecture">
                                            <span>{{ data.item.prefecture }}</span>
                                        </div>
                                    </template>

                                    <template v-slot:cell(registered_at)="data">
                                        <div
                                            v-if="data.item.registered_at"
                                            class="u-palt">
                                            <span class="small">
                                                {{ helper.dateForHuman(data.item.registered_at, 'Asia/Tokyo') }}
                                            </span>
                                            <span
                                                class="small font-weight-bold"
                                                :class="helper.dayForHumanCSS(data.item.registered_at , 'Asia/Tokyo')">
                                                {{ helper.dayForHuman(data.item.registered_at, 'Asia/Tokyo', {bracket: true}) }}
                                            </span>
                                        </div>
                                    </template>

                                    <template v-slot:cell(mailchimp_link)="data">
                                        <div class="mailchimp-link-wrapper">
                                            <b-button
                                                size="sm"
                                                class="mt-2 ml-2"
                                                variant="info"
                                                :href="createMailchimpUrl(data.item)"
                                                target="_blank">
                                                Mailchimpで開く
                                            </b-button>
                                        </div>
                                    </template>

                                    <template v-slot:cell(links)="data">
                                        <div>
                                            <b-button v-if="data.item.stopped_at == null" type="button"
                                                      class="btn btn-success btn-sm m-2" data-toggle="modal"
                                                      data-target="" @click="showModalStopUser(data.item)">利用中
                                            </b-button>

                                            <b-button v-if="data.item.stopped_at != null" type="button"
                                                      class="btn btn-metal btn-sm m-2" data-toggle="modal"
                                                      data-target="" @click="showModalComebackUser(data.item)">停止中
                                            </b-button>

                                            <b-button type="button"
                                                      class="btn btn-yokumiru-blue btn-sm m-2" data-toggle="modal"
                                                      data-target="" @click="showModalEditUser(data.item)">編集
                                            </b-button>

                                            <b-button type="button" class="btn btn-danger btn-sm m-2" data-toggle="modal"
                                                      data-target="" @click="showModalDeleteUser(data.item)">削除
                                            </b-button>
                                        </div>
                                    </template>
                                </b-table>

                                <div class="d-flex flex-wrap justify-content-between align-items-center">
                                    <b-pagination
                                        :total-rows="$store.state.adminUsers.total"
                                        :per-page="$store.state.adminUsers.per_page"
                                        v-model="$store.state.adminUsers.current_page"
                                        @change="fetchUsers">
                                    </b-pagination>

                                    <div class="d-flex flex-wrap align-items-center">
                                        <div class="mr-3 mb-3">
                                            <span class="small">{{ dispPaginationDetail }}</span>
                                        </div>
                                        <div class="mb-3">
                                            <b-button
                                                variant="yokumiru-orange"
                                                @click="downloadCSV"
                                                :disabled="inProgress">
                                                CSVダウンロード
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <admin-user-group-histories-modal/>
        <admin-user-subscription-histories-modal/>
        <admin-user-profile-modal :timezone="timezone"/>
        <admin-doctor-profile-modal/>

        <add-user-modal
            :plans="plans"
            :campaigns="campaigns"
            :userCategories="userCategories"
            :organizations="organizations"
            :companies="companies">
        </add-user-modal>

        <edit-user-modal
            :plans="plans"
            :campaigns="campaigns"
            :userCategories="userCategories"
            :organizations="organizations"
            :companies="companies">
        </edit-user-modal>

        <stop-user-modal/>
        <comeback-user-modal/>
        <delete-user-modal/>
    </div>
</template>

<script>
    import constants from '../../constants'
    import moment from 'moment-timezone'
    import YokumiruHelper from '../../YokumiruHelper'
    import { sprintf } from 'sprintf-js'
    import { mapMutations } from 'vuex'

    export default {
        name: 'Users',

        props: {
            timezone: {
                type: String,
                required: true,
            },
            plans: {
                type: Array,
                required: true,
            },
            campaigns: {
                type: Array,
                required: true,
            },
            mailchimpUrl: {
                type: String,
            }
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                inProgress: false,
                users: null,
                orders: constants.orders,
                organizations: [],
                companies: [],
                userCategories: [],
                userManagementTags: [],
                userMailchimps: [],
                search: {
                    prefecture: null,
                    user_category_id: null,
                    plan_id: null,
                    user_management_tag_id: null,
                    freeword: '',
                    registered_at_gte: null,
                    registered_at_lte: null,
                },
                prefmap: [
                    '北海道',   '青森県',   '岩手県',   '宮城県',
                    '秋田県',   '山形県',   '福島県',   '茨城県',   '栃木県',
                    '群馬県',   '埼玉県',   '千葉県',   '東京都',   '神奈川県',
                    '新潟県',   '富山県',   '石川県',   '福井県',   '山梨県',
                    '長野県',   '岐阜県',   '静岡県',   '愛知県',   '三重県',
                    '滋賀県',   '京都府',   '大阪府',   '兵庫県',   '奈良県',
                    '和歌山県', '鳥取県',   '島根県',   '岡山県',   '広島県',
                    '山口県',   '徳島県',   '香川県',   '愛媛県',   '高知県',
                    '福岡県',   '佐賀県',   '長崎県',   '熊本県',   '大分県',
                    '宮崎県',   '鹿児島県', '沖縄県',
                ],
                fields: [
                    {
                        'key': 'id',
                        'label': '#',
                        sortable: true,
                    },
                    {
                        'key': 'full_name_kana',
                        'label': `${this.$locale.patient}名`,
                        sortable: true,
                    },
                    {
                        'key': 'user_category_id',
                        'label': `${this.$locale.patient}区分`,
                        sortable: true,
                    },
                    {
                        'key': 'plan_id',
                        'label': 'サービスモデル',
                        sortable: true,
                    },
                    {
                        'key': 'email',
                        'label': 'メールアドレス',
                        sortable: true,
                    },
                    {
                        'key': 'user_management_tags.name',
                        'label': '管理用タグ',
                        sortable: false,
                    },
                    {
                        'key': 'user_code',
                        'label': '所属コード',
                        sortable: true,
                    },
                    {
                        'key': 'birthday',
                        'label': '年齢',
                        sortable: true,
                    },
                    {
                        'key': 'prefecture',
                        'label': '都道府県',
                        sortable: false,
                    },
                    {
                        'key': 'registered_at',
                        'label': '登録日',
                        sortable: true,
                    },
                    {
                        'key': 'latest_consultation_start_time',
                        'label': `最新の${this.$locale.consultation_host}予約日`,
                        sortable: true,
                    },
                    {
                        'key': 'consultation_count',
                        'label': `${this.$locale.consultation_host}回数`,
                        sortable: true,
                    },
                    {
                        'key': 'links',
                        'label': '',
                        'class': 'text-center',
                        sortable: false,
                    },
                ],
            }
        },

        computed: {
            /**
             * ページング詳細表示
             * @returns {string}
             */
            dispPaginationDetail: function () {
                if ( this.$store.state.adminUsers.total < 1 ) {
                    return ''
                }
                return `全${this.$store.state.adminUsers.total}件中 ${this.$store.state.adminUsers.from}～${this.$store.state.adminUsers.to}件表示`
            },
        },

        created: function () {
            this.initQueryFromState()
            this.initSearchCondition()

            this.fetchUsers()
            this.fetchUserCategories()
            this.fetchCompanies()
            this.fetchOrganizations()
            this.fetchUserManagementTags()

            if (this.$locale.type === 'consul') {
                this.fields.splice(5, 0, {
                    'key': 'user_coupons_available_all',
                    'label': 'クーポン',
                    sortable: false,
                })
                this.fields.splice(13, 0, {
                    'key': 'mailchimp_link',
                    'label': 'Mailchimp',
                    sortable: false,
                })
            }

            bus.$on('fetch-users', this.fetchUsers)
        },

        beforeDestroy: function () {
            bus.$off('fetch-users')
        },

        methods: {
            ...mapMutations({
                setQuery: 'adminUsers/setQuery',
                setQueries: 'adminUsers/setQueries',
            }),

            /**
             * 検索条件の初期化
             */
            initQueryFromState: function () {
                if (localStorage.getItem('yokumiruWeb')) {
                    const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                    if (data.adminUsers) {
                        this.setQueries(data.adminUsers)
                    }
                }
            },

            /**
             * 検索条件の初期化
             */
            initSearchCondition: function () {
                this.search.prefecture = this.$store.state.adminUsers.prefecture
                this.search.user_category_id = this.$store.state.adminUsers.user_category_id
                this.search.plan_id = this.$store.state.adminUsers.plan_id
                this.search.user_management_tag_id = this.$store.state.adminUsers.user_management_tag_id
                this.search.freeword = this.$store.state.adminUsers.freeword
                this.search.registered_at_gte = this.$store.state.adminUsers.registered_at_gte
                this.search.registered_at_lte = this.$store.state.adminUsers.registered_at_lte
            },

            onChangeSearchPrefecture: async function () {
                await this.setQuery({ key: 'prefecture', value: this.search.prefecture })
                await this.fetchUsers(1)
            },

            onChangeSearchUserCategoryId: async function () {
                await this.setQuery({ key: 'user_category_id', value: this.search.user_category_id })
                await this.fetchUsers(1)
            },

            onChangeSearchPlanId: async function () {
                await this.setQuery({ key: 'plan_id', value: this.search.plan_id })
                await this.fetchUsers(1)
            },

            onChangeSearchUserManagementTagId: async function () {
                await this.setQuery({ key: 'user_management_tag_id', value: this.search.user_management_tag_id })
                await this.fetchUsers(1)
            },

            onChangeSearchFreeword: async function () {
                await this.setQuery({ key: 'freeword', value: this.search.freeword })
                await this.fetchUsers(1)
            },

            onChangeSearchRegisteredAtGte: async function () {
                await this.setQuery({ key: 'registered_at_gte', value: this.search.registered_at_gte })
                await this.fetchUsers(1)
            },

            onChangeSearchRegisteredAtLte: async function () {
                await this.setQuery({ key: 'registered_at_lte', value: this.search.registered_at_lte })
                await this.fetchUsers(1)
            },

            userOrganization: function (user) {
                return this.helper.userOrganization(user) || {}
            },

            userCompany: function (user) {
                return this.helper.userCompany(user) || {}
            },

            /**
             * 会員一覧取得
             *
             * @param {number|object} param
             */
            fetchUsers: async function (param = null) {
                this.users = null

                if (Number.isInteger(param) && param > 0) {
                    await this.setQuery({key: 'current_page', value: param})
                }
                else if (param !== null && param.hasOwnProperty('sortBy')) {
                    await this.setQuery({key: 'sortBy', value: param.sortBy})
                    await this.setQuery({key: 'sortDesc', value: param.sortDesc})
                }

                const endpoint = constants.admin.users.endpoint.base

                axios.get(`${endpoint}${this.buildQuery()}`)
                    .then(({data}) => {
                        this.users = data.data
                        this.setQuery({key: 'current_page', value: data.current_page})
                        this.setQuery({key: 'per_page', value: data.per_page})
                        this.setQuery({key: 'total', value: data.total})
                        this.setQuery({key: 'from', value: data.from})
                        this.setQuery({key: 'to', value: data.to})
                    })
            },

            /**
             * QueryString生成
             *
             * @param {boolean} paginate
             * @return {string}
             */
            buildQuery: function (paginate = true) {
                let query = '?'

                const state = this.$store.state.adminUsers

                if (paginate) {
                    query += `page=${state.current_page}`
                }
                query += `&sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`

                if (state.prefecture) {
                    query += `&prefecture=${state.prefecture}`
                }
                if (state.user_category_id) {
                    query += `&user_category_id=${state.user_category_id}`
                }
                if (state.plan_id) {
                    query += `&plan_id=${state.plan_id}`
                }
                if (state.user_management_tag_id) {
                    query += `&user_management_tag_id=${state.user_management_tag_id}`
                }
                if (state.freeword && state.freeword.length > 0) {
                    query += `&freeword=${state.freeword}`
                }
                if (state.registered_at_gte) {
                    query += `&registered_at_gte=${state.registered_at_gte}`
                }
                if (state.registered_at_lte) {
                    query += `&registered_at_lte=${state.registered_at_lte}`
                }

                return query
            },

            /**
             * 会員区分の取得
             */
            fetchUserCategories: function () {
                axios.get(`${constants.admin.users.endpoint.user_categories}?show=1`)
                    .then(({data}) => {
                        this.userCategories = data
                    })
            },

            /**
             * 法人一覧取得
             */
            fetchCompanies: function () {
                axios.get(`${constants.admin.groups.endpoint.base}?group_type=${constants.groupType.company}`)
                    .then(({data}) => {
                        this.companies = data.data
                    })
            },

            /**
             * 団体一覧取得
             */
            fetchOrganizations: function () {
              axios.get(`${constants.admin.groups.endpoint.base}?group_type=${constants.groupType.organization}`)
                  .then(({data}) => {
                    this.organizations = data.data
                  })
            },

            /**
             * 会員管理用タグ一覧取得
             */
            fetchUserManagementTags: function () {
                axios.get(constants.admin.user_management_tags.endpoint.base)
                    .then(({data}) => {
                        this.userManagementTags = data
                    })
            },

            /**
             * グループ所属履歴モーダル表示
             * @param {object} user
             * @param {object} e
             */
             showModalUserGroupHistories: function (user, e) {
                e.preventDefault()
                bus.$emit('open-modal-user-group-histories', user)
            },

            /**
             * サービスモデル履歴モーダル表示
             * @param {object} user
             * @param {object} e
             */
            showModalSubscriptionHistories: function (user, e) {
                e.preventDefault()
                bus.$emit('open-modal-subscription-histories', user)
            },

            /**
             * 利用停止モーダル表示
             * @param {object} user
             */
            showModalStopUser: function (user) {
                bus.$emit('open-modal-stop-user', user)
            },

            /**
             * 利用再開モーダル表示
             * @param {object} user
             */
            showModalComebackUser: function (user) {
                bus.$emit('open-modal-comeback-user', user)
            },

            /**
             * 削除モーダル表示
             * @param {object} user
             */
            showModalDeleteUser: function (user) {
                bus.$emit('open-modal-delete-user', user)
            },

            /**
             * 追加モーダル表示
             */
            showModalAddUser: function () {
                bus.$emit('open-modal-add-user', this.userCategories, this.companies)
            },

            /**
             * 編集モーダル表示
             */
            showModalEditUser: function (user) {
                bus.$emit( 'open-modal-edit-user', user)
            },

            /**
             * 会員詳細モーダル表示
             */
            showModalUserProfile: function (user, e) {
                e.preventDefault()
                bus.$emit('open-modal-admin-user-profile', user.id)
            },

            /**
             * CSVダウンロード
             */
            downloadCSV: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = `${constants.admin.users.endpoint.base}/export${this.buildQuery(false)}`
                const options = { responseType : 'blob' }

                await axios.get(endpoint, options)
                    .then((response) => {
                        const blob = new Blob([response.data], {
                            type: response.data.type,
                        })
                        saveAs(
                            blob,
                            sprintf(
                                '%s一覧_%s.csv',
                                this.$locale.patient,
                                moment().format('YYYYMMDD')
                            )
                        )
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })

                this.inProgress = false
            },

            createMailchimpUrl: function (user) {
                if (!user.user_mailchimp) return ''

                return `${this.mailchimpUrl}/audience/contact-profile?contact_id=${user.user_mailchimp.contact_id}`
            }
        },
    };
</script>

<style lang="scss" scoped>
.userManagementTagsWrapper {
    overflow-x: scroll;
    white-space: pre;
    width: 120px;
    padding: 5px 0;
    box-sizing: border-box;

    .userManagementTag {
        padding: 3px 5px;
        margin-right: 5px;
        color: #3461b4;
        font-size: .85em;
        background-color: #f2f4f8;
        border: 1px solid #dce4ed;
        border-radius: 2px;
    }
}

.mailchimp-link-wrapper {
    max-width: 200px;
}
</style>

<style lang="scss">
.p-users {
    .b-table {
        min-width: 1800px;

        th, td {
            font-size: .75rem;
        }

        .td-user-coupons {
            overflow-x: scroll;
            white-space: pre;
            width: 160px;
            padding: 5px 0;
            box-sizing: border-box;

            > span {
                display: block;
                padding: 4px 10px;
                color: #212529;
                font-size: 0.75rem;
                text-align: center;
                background-color: #dedede;
                border-radius: 15px;
                margin-right: 5px;

                &:last-child {
                    padding-right: 15px;
                }
            }
        }
    }
}
</style>
